export default __webpack_public_path__ + "static/media/basil-chicken-rice.b8b2d6f6.png";